/**
 * Masonry — пропорция карточки и сколько строк сетки она занимает.
 *
 * Раскладку делает CSS (webapp/css/masonry.css): список остаётся плоским,
 * грид сам ставит карточку в самую короткую колонку. Здесь только числа
 * для каждой карточки: --m-ar (пропорция кадра) и --m-rows (строки кадра).
 *
 * Та же формула на сайте — frontend/src/lib/masonry.ts. Общие тестовые
 * векторы: tests/js/test_masonry.js проверяет обе реализации.
 *
 * Откуда пропорция (первое, что есть):
 *   1. preview_width / preview_height — фактический кадр результата;
 *   2. aspect_ratio — формат «W:H» (заказанный или ближайший к факту);
 *   3. 3:4 — прежняя плитка, ничего не знаем.
 * Экстремальные кадры зажаты в 1:2…2:1: панорама 4:1 в ленте была бы
 * полоской, а высокий скрин — столбом на пол-экрана.
 */
(function (root, factory) {
    'use strict';
    const api = factory();
    root.Masonry = api;
    if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
    'use strict';

    const UNITS = 40;           // строк сетки на ширину колонки (masonry.css --m-units)
    const RATIO_MIN = 0.5;
    const RATIO_MAX = 2;
    const FALLBACK = 3 / 4;

    function parseAspect(value) {
        const m = /^\s*(\d+(?:\.\d+)?)\s*[:x×/]\s*(\d+(?:\.\d+)?)\s*$/.exec(String(value || ''));
        if (!m) return null;
        const w = Number(m[1]);
        const h = Number(m[2]);
        return w > 0 && h > 0 ? w / h : null;
    }

    function clamp(r) {
        return Math.min(RATIO_MAX, Math.max(RATIO_MIN, r));
    }

    /** Пропорция кадра карточки (ширина / высота). */
    function ratioOf(item) {
        const it = item || {};
        const w = Number(it.preview_width);
        const h = Number(it.preview_height);
        if (w > 0 && h > 0) return clamp(w / h);
        const a = parseAspect(it.aspect_ratio);
        return a ? clamp(a) : FALLBACK;
    }

    /** Строки сетки под кадр. Подпись и отступ добавляет CSS листинга. */
    function rows(ratio) {
        return Math.ceil(UNITS / ratio);
    }

    /** CSS-переменные карточки: { '--m-ar': '0.75', '--m-rows': '54' }. */
    function vars(item) {
        const r = ratioOf(item);
        return {
            '--m-ar': String(Math.round(r * 10000) / 10000),
            '--m-rows': String(rows(r)),
        };
    }

    /** Проставить переменные на DOM-узел карточки. */
    function apply(el, item) {
        if (!el) return;
        const v = vars(item);
        Object.keys(v).forEach((k) => el.style.setProperty(k, v[k]));
    }

    return { UNITS, RATIO_MIN, RATIO_MAX, FALLBACK, parseAspect, ratioOf, rows, vars, apply };
});
